// src/index.js

import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

const isProd = process.env.NODE_ENV === "production";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <BrowserRouter basename={isProd ? "/app" : "/"}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
